import { useState } from 'react';

import SearchNavbarIcon from '@/shared-components/icons/components/navigation/SearchNavbarIcon';
import XIcon from '@/shared-components/icons/components/public/XIcon';

import './styles/Searchbar.css';

export default function Searchbar({ query, setQuery, categorySelected }) {
  const categories = ['Artworks', 'Galleries', 'Artists', 'Users', 'Artlists'];
  const [selectedCategory, setSelectedCategory] = useState(0);

  const handleSpanClick = (index, category) => {
    setSelectedCategory(index);
    categorySelected(category);
  };

  return (
    <>
      <div className="searchbar__container">
        <SearchNavbarIcon className="searchbar__icon"/>

        <input 
          type="text" 
          className="searchbar__input" 
          value={query.q ? query.q : ""} 
          onInput={(e)=>setQuery({ ...query, q: e.target.value })} 
          placeholder="Search" 
          spellCheck={false} autoComplete="off"
        />

        {query.q && <XIcon className="searchbar__clear" onClick={()=>setQuery({ ...query, q: "" })}/>}
      </div>
      <div className="search__group__sections">
        {categories.map((item, index) => (
          <span
            key={index}
            className={`search__group__item ${selectedCategory === index ? 'selected' : ''}`}
            onClick={() => handleSpanClick(index, categories[index])}
          >
            {item}
          </span>
        ))}
      </div>
    </>
  );
}
